import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";
import Image from "next/image";
import Link from "next/link";
import Iframe from "react-iframe";

import InquiriesSchema from "@/kyna/lib/validations/InquiriesSchema";
import { useFormik } from "formik";
import { KTPost } from "@/kyna/lib/db";
import InputForm from "@/kyna/forms/InputForm";

import HeaderNav from "../../includes/HeaderNav";
import Spinner from "@/kyna/ui/preloader/Spinner";

import Footer from "../../includes/Footer";

import toast from "react-hot-toast";
import { KNThemeSuccess, KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
import TextField from "@/kyna/forms/RichTextField/TextField";
import { useRouter } from "next/router";
import RenderText from "@/kyna/forms/RichTextField/plugins/RenderText";
import Reaptcha from "reaptcha";
import { INQUIRY_OPTION } from "@/kyna/lib/StandardReferences";

import sendgrid from "@sendgrid/mail";

import LocationIcon from "../../../public/assets/img/icons/location-icon.svg";
import EmailIcon from "../../../public/assets/img/icons/email-icon.svg";
import PhoneIcon from "../../../public/assets/img/icons/phone-icon.svg";
import ClockIcon from "../../../public/assets/img/icons/clock-icon.svg";
import FBicon from 'public/assets/img/icons/facebook-icon.svg';
import Twittericon from 'public/assets/img/icons/twitter-icon.svg';
import IGicon from 'public/assets/img/icons/instagram-icon.svg';
import YTicon from 'public/assets/img/icons/youtube-icon.svg';
import TikTokicon from 'public/assets/img/icons/tiktok-icon.svg';

sendgrid.setApiKey(process.env.SENDGRID_API_KEY);

const Contact = (props) => {
  const router = useRouter();
  const GOOGLE_SITE_KEY = process.env.NEXT_PUBLIC_GOOGLE_SITE_KEY;
  const recaptchaRef = useRef();
  const [captchaIsLoaded, setCaptchaIsLoaded] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState(null);
  const [formMessageType, setFormMessageType] = useState(null);
  const [formResponse, setFormResponse] = useState({});
  const [SchemaErrors, setSchemaErrors] = useState({});
  const [inquiryIntialValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    contact_no: "",
    email: "",
    message: "",
    token: "",
    category: "",
  });
  const [primaryID, setPrimaryID] = useState(0);
  const [contactEmail, setContactEmail] = useState("hello@pmha.org.ph");

  const verify = () => {
    recaptchaRef.current
      .getResponse()
      .then((res) => {
        console.log("Success" + res)
        formik.setFieldValue("token", res);
      }).catch((err) => {
        console.log("Error" + err)
        formik.setFieldError("token", "Error Verification, Please try again.");
      })
  };

  const captchaIsExpired = () => {
    formik.setFieldValue("token", "");
  }
  useEffect(() => {
    switch (formik.values.category) {
      case 'General':
        return setContactEmail('hello@pmha.org.ph')
      case 'Job Vacancies':
        return setContactEmail('careers@pmha.org.ph')
      case 'Membership':
        return setContactEmail('membership@pmha.org.ph')
      case 'Partnership and Donations':
        return setContactEmail('oned@pmha.org.ph')
      case 'Lecture / Training / Advocacy / Research':
        return setContactEmail('eard@pmha.org.ph')
      case 'Consultations / Bookings / Service Fee / Internship':
        return setContactEmail('cisd@pmha.org.ph')
      default:
        return setContactEmail('hello@pmha.org.ph')
    }
  })

  const [tokenValidation, setTokenValidation] = useState("");
  const submitHandler = async (values) => {
    setLoading(true);
    setFormMessage(null);
    setFormMessageType(null);

    console.log("Submit");
    console.log("Submit values", values);
    // console.log("contactEmail:", contactEmail);
    if(values.token == ""){
      setTokenValidation("Captcha is required!")
      setLoading(false)
      return
    }
    // return
    let message = <RenderText initialValue={JSON.parse(values.message)} />;

    const BaseURL = process.env.NEXT_PUBLIC_VERCEL_URL;

    const res = await fetch("/api/sendgrid", {
      body: JSON.stringify({
        email: contactEmail,
        // from: contactEmail,
        contact_no: values.contact_no,
        fullname: values.last_name + ", " + values.first_name,
        subject: "New Inquiry from " + values.first_name + " " + values.last_name,
        message: message.props.initialValue[0].children[0].text,
        html: `
            <!doctype html>
            <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
            
            <head>
              <title>Contact</title>
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <style type="text/css">
                #outlook a {
                  padding: 0;
                }
                body {
                  margin: 0;
                  padding: 0;
                  -webkit-text-size-adjust: 100%;
                  -ms-text-size-adjust: 100%;
                }
                table,
                td {
                  border-collapse: collapse;
                  mso-table-lspace: 0pt;
                  mso-table-rspace: 0pt;
                }
                img {
                  border: 0;
                  height: auto;
                  line-height: 100%;
                  outline: none;
                  text-decoration: none;
                  -ms-interpolation-mode: bicubic;
                }
                p {
                  display: block;
                  margin: 13px 0;
                }
                table.client-details tbody tr td {
                  vertical-align: top;
                  padding-left: 5px;
                  padding-right: 5px;
                }
                .tbl-label {
                  width: 35%;
                }
                .tbl-value {
                  width: 65%;
                }
              </style>
            
              <link rel="preconnect" href="https://fonts.googleapis.com">
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
              <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">
            
              <style type="text/css">
                @import url(https://fonts.googleapis.com/css?family=Roboto:400,700);
              </style>
            
              <style type="text/css">
                @media only screen and (min-width:480px) {
                  .mj-column-per-100 {
                    width: 100% !important;
                    max-width: 100%;
                  }
                  .mj-column-per-35 {
                    width: 35% !important;
                    max-width: 35%;
                  }
                  .mj-column-per-65 {
                    width: 65% !important;
                    max-width: 65%;
                  }
                }
              </style>
              <style media="screen and (min-width:480px)">
                .moz-text-html .mj-column-per-100 {
                  width: 100% !important;
                  max-width: 100%;
                }
                .moz-text-html .mj-column-per-35 {
                  width: 35% !important;
                  max-width: 35%;
                }
                .moz-text-html .mj-column-per-65 {
                  width: 65% !important;
                  max-width: 65%;
                }
              </style>
              <style type="text/css">
                @media only screen and (max-width:480px) {
                  table.mj-full-width-mobile {
                    width: 100% !important;
                  }
                  td.mj-full-width-mobile {
                    width: auto !important;
                  }
            
                  .site-logo,
                  .site-name {
                    display: block;
                    width: 100%;
                  }
                  .site-logo {
                    padding-bottom: 15px;
                  }
                  .site-name > div {
                    padding-left: 0 !important;
                  }
                  .donation-details {
                    padding: 10px 0 0 !important;
                  }
            
                }
              </style>
            </head>
            
            <body style="word-spacing: normal; background-color: #f1f1f1;">
              <div style="background-color: #f1f1f1; padding-top: 20px; padding-left: 20px; padding-right: 20px;">
                <div style="margin: 30px auto; background-color: #ffffff; max-width: 600px;">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; background: #193e8c;">
                    <tbody>
                      <tr>
                        <td style="direction: ltr; text-align: center;">
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width:100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="" style="padding: 20px 25px; word-break: break-word;">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: collapse; border-spacing: 0px; margin: auto;">
                                      <tbody>
                                        <tr>
                                          <td class="site-logo" style="">
                                            <img alt="PMHA" height="auto" src="https://ucarecdn.com/b68fe996-fcc1-479c-ad51-778f8f283205/" style="border: 0; display: block; outline: none; text-decoration: none; height: auto; width: 100%; max-width: 80px; margin: auto;" />
                                          </td>
                                          <td class="site-name" style="">
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #ffffff; padding-left: 20px; max-width: 350px; margin: auto;">Philippine Mental Health Association, Inc.</div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="direction: ltr; padding: 0; text-align: center;">
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="padding: 30px 25px 0; word-break: break-word;">
                                    <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #193e8c;">Inquiry</div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%; max-width: 550px;">
                              <tbody>
                                <tr>
                                  <td style="direction:ltr; font-size: 0px; padding: 30px 20px 20px;text-align:center;">
                                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                                        <tbody>
                                          <tr>
                                            <td align="center" style="font-size: 0px; padding: 10px 0; word-break: break-word;">
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Hi, <strong>PMHA Team!</strong></div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">You have received a new inquiry.</div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px; margin-bottom: 30px;">
                                                Here are the details:
                                                <div class="donation-details" style="padding: 15px;">
                                                  <table class="client-details" style="width: 100%;">
                                                    <tbody>
                                                      <tr>
                                                        <td class="tbl-label" style="font-size: 14px;">Inquiry Category:</td>
                                                        <td class="tbl-value" style="font-size: 14px;"><strong>${values.category}</strong></td>
                                                      </tr>
                                                      <tr>
                                                        <td class="tbl-label" style="font-size: 14px;">Name:</td>
                                                        <td class="tbl-value" style="font-size: 14px;"><strong>${values.last_name}, ${values.first_name}</strong></td>
                                                      </tr>
                                                      <tr>
                                                        <td class="tbl-label" style="font-size: 14px;">Email:</td>
                                                        <td class="tbl-value" style="font-size: 14px;"><strong>${values.email}</strong></td>
                                                      </tr>
                                                      <tr>
                                                        <td class="tbl-label" style="font-size: 14px;">Contact No:</td>
                                                        <td class="tbl-value" style="font-size: 14px;"><strong>${values.contact_no}</strong></td>
                                                      </tr>
                                                      <tr>
                                                        <td class="tbl-label" colspan="2" style="font-size: 14px;">Message:</td>
                                                      </tr>
                                                      <tr>
                                                        <td class="tbl-value" colspan="2" style="font-size: 14px;"><strong>${message.props.initialValue[0].children[0].text}</strong></td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: center; color: #000000;">To check the inquiry, please login to your account.</div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: center; color: #000000; padding-top: 20px; padding-bottom: 30px;">
                                                <a href="${process.env.NEXT_PUBLIC_VERCEL_URL}/app/dashboard" target="_blank" style="font-size: 14px; font-weight: 600; text-transform: uppercase; text-decoration: none; letter-spacing: 1px; background-color: #2eafcf; color: #fff; padding: 8px 15px; border-radius: 50px; display: block; max-width: 170px; width: 100%; margin: auto;">Click here to Login</a>
                                              </div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 12px; line-height: 20px; text-align: center; color: #000000; padding-bottom: 20px;">If the button above is not working, please <a href="${process.env.NEXT_PUBLIC_VERCEL_URL}/app/dashboard" target="_blank" style="text-decoration: underline; color: #2eafcf;">click here</a> to login.</div>
                                            </td>
                                          </tr>
            
            
                                          <!-- EMAIL NOTIFICATION FOOTER -->
                                          <tr>
                                            <td align="center" style="font-size: 0px; padding-top: 15px; word-break: break-word; border-top: 1px solid #eee;">
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">
                                                <ul style="list-style: none; padding-left: 0; text-align: center; margin-top: 0; margin-bottom: 5px;">
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.facebook.com/PMHAofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/0869ab43-f54d-4f83-8781-8fed79d7938b/" alt="Facebook">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://twitter.com/PMHAofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/f8e6e9fd-7f11-4515-b088-e5567a9915ba/" alt="Twitter">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.instagram.com/pmhaofficial/" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/6b306f1a-796f-404f-86ba-400a0f766e83/" alt="Instagram">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/a822e322-e351-4d21-8bf7-14ac85a19f28/" alt="Youtube">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.tiktok.com/@pmhaofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/2ed79507-7d8e-499c-afe6-85b2988aeea9/" alt="TikTok">
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 12px; font-weight: 400; line-height: 22px; text-align: center; color: #000000; letter-spacing: 2px;">PMHA © ${new Date().getFullYear()}</div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </body>
            
            </html>
            </br>`
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });
    const { error } = await res.json();
    if (error) {
      console.log(error);
      return;
    }

    let postData = {
      "last_name": values.last_name,
      "first_name": values.first_name,
      "email": values.email,
      "contact_no": values.contact_no,
      "message": values.message,
      "category": values.category
    }
    // return
    console.log('postData: ', postData)
    const messageSaveResponse = await KTPost('/api/inquiries', postData);


    setLoading(false)
    setFormResponse(messageSaveResponse)
    console.log("Message post messageSaveResponse!!!!!->", messageSaveResponse)

    if (messageSaveResponse.status != 200) {
      console.log("error")
      console.log(messageSaveResponse.error)
      toast.dismiss();
      toast.error("There's an error occur, please try again.", { ...KNThemeError });

      return;
    }

    if (messageSaveResponse.status == 200 && messageSaveResponse.data.code == 422) {
      console.log("error")
      console.log(messageSaveResponse)

      // setFormMessage("Branch already exist!")
      // setFormMessageType("text-red-400")
      toast.dismiss();
      toast.error("Message error!", { ...KNThemeError, position: 'top-center' });


      setLoading(false)
      return;
    }
    toast.dismiss();
    toast.success("Message has been sent!", { ...KNThemeSuccess, position: 'top-center' });

    // setFormMessage("Branch has been saved!")
    // setFormMessageType("text-green-400")

    // SUCCESSFUL SAVE BRANCH TABLE
    // NEXT ALL THE CHAIN REQUESTS BELOW       

    // return;

    setLoading(false)
    resetFormikValues()
    router.push('/')

  };

  const resetFormikValues = () => {
    console.log("resetFormikValues");
    Object.entries(inquiryIntialValues).map((q, i) => {
      const key = q[0];
      // console.log("Q FIELD: " + key + ": " + inquiryIntialValues[key])
      formik.setFieldValue(key, inquiryIntialValues[key]);
      formik.setTouched({ inquiryIntialValues });
    });

    // setFieldPrimaryID(0)
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: inquiryIntialValues,
    validationSchema: InquiriesSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
      // return
      submitHandler(values);
    },
  });
  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* CONTACT */}
      <section className="max-w-screen-xl mx-auto lg:mt-44 mt-36 sm:px-10 px-8 lg:pb-24 pb-8">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12">
          <div className="">
            <h1 className="md:text-4xl text-3xl leading-tight mb-4">Send us a message</h1>
            <p className="lg:text-xl text-lg mb-8">Talk to us so we can help you better.</p>

            <form onSubmit={formik.handleSubmit}>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                <div className="form-group !mb-0">
                  <label className='control-label block mb-1'>Last Name <span className="text-red-600">*</span></label>
                  <InputForm
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder="Last Name"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full md:!mb-[15px] !mb-0"
                    helpBlockClass={"text-red-400"}
                    helpBlockText={SchemaErrors?.id || SchemaErrors.id}
                  />
                  <div className="help-block"></div>
                </div>
                <div className="form-group !mb-0">
                  <label className='control-label block mb-1'>First Name <span className="text-red-600">*</span></label>
                  <InputForm
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder="First Name"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                  />
                  <div className="help-block"></div>
                </div>
              </div>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                <div className="form-group !mb-0">
                  <label className='control-label block mb-1'>Email Address <span className="text-red-600">*</span></label>
                  <InputForm
                    type="text"
                    id="email"
                    name="email"
                    placeholder="Email Address"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full md:!mb-[15px] !mb-0"
                  />
                  <div className="help-block"></div>
                </div>
                <div className="form-group !mb-0">
                  <label className='control-label block mb-1'>Contact No <span className="text-red-600">*</span></label>
                  <InputForm
                    type="text"
                    id="contact_no"
                    name="contact_no"
                    placeholder="Contact Number"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                  />
                  <div className="help-block"></div>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-3">
                <div className="form-group !mb-0">
                  <label className='control-label block mb-1'>Select Inquiry Category <span className="text-red-600">*</span></label>
                  <select name="category" id="category"
                    className="form-control"
                    onChange={(e) => {
                      // handleChange(e)
                      const { name, value } = e.target;
                      console.log("category", value)
                      formik.setFieldValue('category', value)
                    }}
                    onBlur={formik.handleBlur}>
                    <option value="">Select Category</option>
                      {
                        INQUIRY_OPTION.map((i,key) => {
                        return (
                          <option key={key} value={i.value}>{i.label}</option>
                        )
                        })
                      }
                  </select>
                  <div className="help-block text-red-400 text-xs mt-2">
                    {formik.touched.category && formik.errors.category && (
                      <div>{formik.errors.category}</div>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label className='control-label block mb-1'>Message <span className="text-red-600">*</span></label>
                  <TextField
                    id="message"
                    name="message"
                    formik={formik}
                    withFormik={true}
                    placeholder=""
                    className="w-full !min-h-[250px]"
                    onBlur={formik.handleBlur} 
                  />
                  <div className="help-block text-red-400 text-xs mt-2">
                    {formik.touched.message && formik.errors.message && (
                      <div>{formik.errors.message}</div>
                    )}
                  </div>
                  {/* <pre>{JSON.stringify(formik,null,1)}</pre> */}
                  <div className="help-block"></div>
                </div>
                <div>
                  <Reaptcha
                    sitekey={GOOGLE_SITE_KEY}
                    ref={recaptchaRef}
                    onExpire={captchaIsExpired}
                    onVerify={verify}
                  />
                  <div className="text-red-400 text-xs help-block">
                      <div>{tokenValidation}</div>
                  </div>
                </div>
                {/* <pre>{JSON.stringify(GOOGLE_SITE_KEY,null,1)}</pre> */}
                <div className="form-group text-right">
                  <button
                    type="submit"
                    disabled={
                      isLoading ? true : false
                    }
                    className="btn-secondary rounded-full"
                  >
                    <Spinner isLoading={isLoading} />
                    {!isLoading && "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
            
          <div className="bg-gray-100 sm:p-10 p-6 lg:mt-0 mt-10 lg:block hidden">
            <div className="flex mb-5">
              <div className="w-[20px] mt-2">
                <Image src={LocationIcon} alt="Location" />
              </div>
              <div className="pl-3">
                <h2 className="text-blue text-base mb-1">Philippine Mental Health Association, Inc.</h2>
                <p>18 East Ave, Diliman, Quezon City, <br />1100 Metro Manila</p>
              </div>
            </div>
            <div className="flex">
              <div className="w-[16px] mt-[3px]">
                <Image src={EmailIcon} alt="Email" />
              </div>
              <div className="pl-3">
                <Link href="mailto:hello@pmha.org.ph"><a className="text-black/70">hello@pmha.org.ph</a></Link>
              </div>
            </div>
            <div className="flex">
              <div className="w-[18px] mt-[2px]">
                <Image src={ClockIcon} alt="Clock" />
              </div>
              <div className="pl-3">
                <p>Office Schedule: Monday - Friday (8:00AM - 5:00PM)</p>
              </div>
            </div>
            
            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Office of the National Executive Director</h3>
              <div className="flex">
                <div className="w-[16px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:oned@pmha.org.ph"><a className="text-black/70">oned@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[18px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:89212093"><a className="text-black/70">8921-2093</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Clinical and Intervention Services Department</h3>
              <div className="flex">
                <div className="w-[16px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:cisd@pmha.org.ph"><a className="text-black/70">cisd@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[18px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:09175652036"><a className="text-black/70">0917 565 2036</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Education, Advocacy and Research Department</h3>
              <div className="flex">
                <div className="w-[16px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:eard@pmha.org.ph"><a className="text-black/70">eard@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[18px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:09175652037"><a className="text-black/70">0917 565 2037</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Accounting Department</h3>
              <div className="flex">
                <div className="w-[16px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:accounting@pmha.org.ph"><a className="text-black/70">accounting@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[18px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:89286930"><a className="text-black/70">8928-6930</a></Link>
                </div>
              </div>
            </div>
            
            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Membership</h3>
              <div className="flex">
                <div className="w-[16px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:membership@pmha.org.ph"><a className="text-black/70">membership@pmha.org.ph</a></Link>
                </div>
              </div>
            </div>


            <div className="flex pt-10">
              <div className="contact-social-icon social-icon facebook-icon pr-6">
                <Link href="https://www.facebook.com/PMHAofficial" passHref>
                  <a target={"_blank"} rel="noreferrer"><Image src={FBicon} alt="Facebook" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://twitter.com/PMHAofficial">
                  <a target={"_blank"} rel="noreferrer"><Image src={Twittericon} alt="Twitter" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://www.instagram.com/pmhaofficial/">
                  <a target={"_blank"} rel="noreferrer"><Image src={IGicon} alt="Instagram" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w">
                  <a target={"_blank"} rel="noreferrer"><Image src={YTicon} alt="Youtube" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6 w-[40px]">
                <Link href="https://www.tiktok.com/@pmhaofficial">
                  <a target={"_blank"} rel="noreferrer"><Image src={TikTokicon} alt="TikTok" /></a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-100 lg:hidden block">
        <div className="sm:px-10 px-8 py-12">
            <div className="flex mb-5">
              <div className="w-[18px] mt-2">
                <Image src={LocationIcon} alt="Location" />
              </div>
              <div className="pl-3">
                <h2 className="text-blue text-base mb-1">Philippine Mental Health Association, Inc.</h2>
                <p>18 East Ave, Diliman, Quezon City, <br />1100 Metro Manila</p>
              </div>
            </div>
            <div className="flex">
              <div className="w-[15px] mt-[3px]">
                <Image src={EmailIcon} alt="Email" />
              </div>
              <div className="pl-3">
                <Link href="mailto:hello@pmha.org.ph"><a className="text-black/70">hello@pmha.org.ph</a></Link>
              </div>
            </div>
            <div className="flex">
              <div className="w-[16px] mt-[2px]">
                <Image src={ClockIcon} alt="Clock" />
              </div>
              <div className="pl-3">
                <p>Office Schedule: Monday - Friday (8:00AM - 5:00PM)</p>
              </div>
            </div>
            
            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Office of the National Executive Director</h3>
              <div className="flex">
                <div className="w-[15px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:oned@pmha.org.ph"><a className="text-black/70">oned@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[16px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:89212093"><a className="text-black/70">8921-2093</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Clinical and Intervention Services Department</h3>
              <div className="flex">
                <div className="w-[15px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:cisd@pmha.org.ph"><a className="text-black/70">cisd@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[16px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:09175652036"><a className="text-black/70">0917 565 2036</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Education, Advocacy and Research Department</h3>
              <div className="flex">
                <div className="w-[15px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:eard@pmha.org.ph"><a className="text-black/70">eard@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[16px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:09175652037"><a className="text-black/70">0917 565 2037</a></Link>
                </div>
              </div>
            </div>

            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Accounting Department</h3>
              <div className="flex">
                <div className="w-[15px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:accounting@pmha.org.ph"><a className="text-black/70">accounting@pmha.org.ph</a></Link>
                </div>
              </div>
              <div className="flex">
                <div className="w-[16px] mt-[2px]">
                  <Image src={PhoneIcon} alt="Phone" />
                </div>
                <div className="pl-3">
                  <Link href="tel:89286930"><a className="text-black/70">8928-6930</a></Link>
                </div>
              </div>
            </div>
            
            <div className="pt-10">
              <h3 className="text-base text-blue mb-[5px]">Membership</h3>
              <div className="flex">
                <div className="w-[15px] mt-[3px]">
                  <Image src={EmailIcon} alt="Email" />
                </div>
                <div className="pl-3">
                  <Link href="mailto:membership@pmha.org.ph"><a className="text-black/70">membership@pmha.org.ph</a></Link>
                </div>
              </div>
            </div>


            <div className="flex pt-10">
              <div className="contact-social-icon social-icon facebook-icon pr-6">
                <Link href="https://www.facebook.com/PMHAofficial" passHref>
                  <a target={"_blank"} rel="noreferrer"><Image src={FBicon} alt="Facebook" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://twitter.com/PMHAofficial">
                  <a target={"_blank"} rel="noreferrer"><Image src={Twittericon} alt="Twitter" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://www.instagram.com/pmhaofficial/">
                  <a target={"_blank"} rel="noreferrer"><Image src={IGicon} alt="Instagram" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6">
                <Link href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w">
                  <a target={"_blank"} rel="noreferrer"><Image src={YTicon} alt="Youtube" /></a>
                </Link>
              </div>
              <div className="contact-social-icon social-icon pr-6 w-[40px]">
                <Link href="https://www.tiktok.com/@pmhaofficial">
                  <a target={"_blank"} rel="noreferrer"><Image src={TikTokicon} alt="TikTok" /></a>
                </Link>
              </div>
            </div>
          </div>
      </section>


      {/* MAP */}
      <section>
        <div className="map text">
          <Iframe
            url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7720.566456178215!2d121.04347832447323!3d14.639857359109806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b7a5d875343d%3A0x159f6356fa3a97a0!2sPhilippine%20Mental%20Health%20Association!5e0!3m2!1sen!2sph!4v1647826729980!5m2!1sen!2sph"
            width="100%"
            height="450px"
            id="contact_map"
            className="map-wrap"
            display="initial"
            position="relative"
          />
        </div>
      </section>
      <KNToaster />


      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default Contact;
